import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import propTypes from 'prop-types'
import { formatDateTime } from '@atheneum/api/dist/lib'
import InfiniteScroll from 'react-infinite-scroller'
import './Logs.sass'
import ACL from '@components/ACL'
import Spinner from '@components/spinner'
import {
  AccountCreateTemplate,
  AccountUpdateTemplate,
  ProjectCreateTemplate,
  ProjectUpdateTemplate,
  InvoicingEntityUpdateTemplate,
  ContractCreateTemplate,
  EPLCreateTemplate,
  ParentAccountCreateTemplate,
  ParentAccountUpdateTemplate,
  CPDCreateTemplate,
  ExpertUpdateSelfTemplate,
  ExpertAvailablityToEplCreateTemplate,
  EmailConfirmTemplate,
  ExpertCompleteProfile,
  UserLoginTemplate,
  OfficeCreateTemplate,
  OfficeUpdateTemplate,
  ClientToProjectAvailabilityTemplate,
  FeeCreateLog,
  ExpertUpdateOtherTemplate,
  ExpertSetComplianceSignedTemplate,
  ExpertCreateTemplate,
  ClientCreateTemplate,
  ClientUpdateOtherTemplate,
  UserSignupTemplate,
  InvoicingEntityCreateTemplate,
  FeeUpdateLog,
  ContractUpdateTemplate,
  PasswordChangedTemplate,
  EmployeeUpdateOtherTemplate,
  EmployeeUpdateSelfTemplate,
  EmployeeCreateTemplate,
  ExtractEplsEmailSent,
  MissingTemplate
} from './LogTemplates'

class Logs extends Component {
  static propTypes = {
    type: propTypes.string,
    itemId: propTypes.number,
    logStore: propTypes.object.isRequired
  }

  constructor (props) {
    super(props)

    if (props.itemId && props.type) {
      props.logStore.id = props.itemId
      props.logStore.type = props.type
    }

    this.props.logStore.clean()
    if (props.itemId && props.type) {
      this.props.logStore.objectId = props.itemId
      this.props.logStore.objectType = props.type
    }
    this.props.logStore.getLogs()
  }

  getLogs = page => {
    this.props.logStore.getLogs()
  }

  render () {
    const store = this.props.logStore
    return (
      <div>
        <h2>Recent changes and updates</h2>
        {this.props.logStore.count === 0 ? (
          'No logs'
        ) : (
          <InfiniteScroll
            hasMore={store.logs.length < store.count}
            loadMore={this.getLogs}
            loader={<Spinner smallMargin />}
          >
            {this.props.logStore.logs.map(log => (
              <Log key={log.id} log={log} />
            ))}
          </InfiniteScroll>
        )}
      </div>
    )
  }
}

// LogContainer - aligns and adds styling to every log item it receives as
// children
export const Log = inject('modalStore')(
  observer(
    class Log extends Component {
      static propTypes = {
        log: propTypes.object,
        modalStore: propTypes.object,
        noDetails: propTypes.bool
      }

      showDiff = () => {
        this.props.modalStore.show({
          type: 'REVISION_DIFF_MODAL',
          props: {
            log: this.props.log
          }
        })

        return false
      }

      showExtractEplsInfo = () => {
        this.props.modalStore.show({
          type: 'EXTRACT_EPLS_INFO_MODAL',
          props: {
            log: this.props.log
          }
        })
      }

      showLog = log => {
        switch (log.type) {
          case 'account.create':
            return <AccountCreateTemplate log={log} />
          case 'expert.completeProfile':
            return <ExpertCompleteProfile log={log} />
          case 'email.confirm':
            return <EmailConfirmTemplate log={log} />
          case 'contract.create':
            return <ContractCreateTemplate log={log} />
          case 'account.update':
            return <AccountUpdateTemplate log={log} />
          case 'client.updateOther':
            return <ClientUpdateOtherTemplate log={log} />
          case 'clientToProjectAvailability.create':
            return <ClientToProjectAvailabilityTemplate log={log} />
          case 'expertAvailabilityToEpl.create':
            return <ExpertAvailablityToEplCreateTemplate log={log} />
          case 'expert.signup':
            return <UserSignupTemplate log={log} />
          case 'expert.updateSelf':
            return <ExpertUpdateSelfTemplate log={log} />
          case 'client.signup':
            return <UserSignupTemplate log={log} />
          case 'expert.create':
            return <ExpertCreateTemplate log={log} />
          case 'expert.updateOther':
            return <ExpertUpdateOtherTemplate log={log} />
          case 'expert.setComplianceSigned':
            return <ExpertSetComplianceSignedTemplate log={log} />
          case 'employee.create':
            return <EmployeeCreateTemplate log={log} />
          case 'employee.updateSelf':
            return <EmployeeUpdateSelfTemplate log={log} />
          case 'employee.updateOther':
            return <EmployeeUpdateOtherTemplate log={log} />
          case 'client.create':
            return <ClientCreateTemplate log={log} />
          case 'consultationPaymentDetail.create':
            return <CPDCreateTemplate log={log} />
          case 'project.create':
            return <ProjectCreateTemplate log={log} />
          case 'project.update':
            return <ProjectUpdateTemplate log={log} />
          case 'epl.create':
            return <EPLCreateTemplate log={log} />
          case 'user.login':
            return <UserLoginTemplate log={log} />
          case 'fee.create':
            return <FeeCreateLog log={log} />
          case 'fee.update':
            return <FeeUpdateLog log={log} />
          case 'contract.update':
            return <ContractUpdateTemplate log={log} />
          case 'user.passwordChange':
            return <PasswordChangedTemplate log={log} />
          case 'invoicingEntity.create':
            return <InvoicingEntityCreateTemplate log={log} />
          case 'invoicingEntity.update':
            return <InvoicingEntityUpdateTemplate log={log} />
          case 'office.create':
            return <OfficeCreateTemplate log={log} />
          case 'office.update':
            return <OfficeUpdateTemplate log={log} />
          case 'parentAccount.create':
            return <ParentAccountCreateTemplate log={log} />
          case 'parentAccount.update':
            return <ParentAccountUpdateTemplate log={log} />
          case 'project.extractEplEmailSent':
            return <ExtractEplsEmailSent log={log} />
          default:
            return <MissingTemplate log={log} />
        }
      }

      render () {
        return (
          <div className='logs__log-container'>
            <div className='logs__log-container__inner'>
              <div>{this.showLog(this.props.log)}</div>
              <ACL roles={['Admin']}>
                {this.props.log.revision_hash && !this.props.noDetails && (
                  <div>
                    <span className='link' onClick={this.showDiff}>
                      details
                    </span>
                  </div>
                )}
              </ACL>
              {this.props.log.type === 'project.extractEplEmailSent' && (
                <span className='link' onClick={this.showExtractEplsInfo}>
                  details
                </span>
              )}
            </div>
            <div className='logs__log-container__log-date'>
              {formatDateTime(this.props.log.createdAt)}
            </div>
          </div>
        )
      }
    }
  )
)

export default inject('logStore', 'modalStore')(observer(Logs))
